exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-picker-toggle{cursor:pointer}.color-picker-dropdown{padding:.5rem}.color-picker-container{margin:-6px 0 0 -6px;display:flex;flex-wrap:wrap}.color-picker-container>*{margin:6px 0 0 6px}.color-picker-option{display:flex;align-items:center;justify-content:center;cursor:pointer}.color-picker-option .color-picker-remove{height:75%;width:75%;background:linear-gradient(to top right,transparent 0,transparent calc(50% - 2.4px),var(--fts-danger) 50%,transparent calc(50% + 2.4px),transparent)}", ""]);

// exports
